import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import api from '../../api';
import { UserContext } from '../../context/UserContext';

export default function InformeIvaOperacionesPage() {
  const { currentUser } = useContext(UserContext);
  const canManage = Boolean(currentUser?.navAccess?.canManageNav);
  const [audit, setAudit] = useState([]);
  const [auditFilter, setAuditFilter] = useState('');

  const loadAudit = useCallback(async () => {
    const { data } = await api.get('/informes-iva/audit', { params: { limit: 150 } });
    setAudit(data || []);
  }, []);

  useEffect(() => {
    loadAudit().catch((e) => toast.error(e.response?.data?.error || e.message));
  }, [loadAudit]);

  const auditFiltrada = audit.filter((row) => {
    if (!auditFilter.trim()) return true;
    const q = auditFilter.toLowerCase();
    return `${row.action} ${row.entityType} ${row.meta ? JSON.stringify(row.meta) : ''}`.toLowerCase().includes(q);
  });

  return (
    <div className="max-w-4xl mx-auto px-4 py-10 space-y-8">
      <div>
        <p className="text-sm text-slate-500">
          <Link to="/informes-iva" className="text-indigo-600 hover:underline">
            ← Panel del mes
          </Link>
        </p>
        <h1 className="text-2xl font-bold text-slate-900 mt-1">Auditoría Informes IVA</h1>
        <p className="text-sm text-slate-600 mt-2">
          Registro de acciones del módulo.
          {canManage && (
            <>
              {' '}
              Digest, crons y automatización en{' '}
              <Link to="/informes-iva/administracion" className="text-indigo-600 underline">
                Administración
              </Link>
              .
            </>
          )}
        </p>
      </div>

      <section className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm space-y-4 text-sm">
        <div className="flex flex-wrap justify-between gap-3 items-center">
          <h2 className="font-semibold text-slate-900">Eventos recientes</h2>
          <button type="button" onClick={loadAudit} className="text-indigo-600 underline text-xs">
            Actualizar
          </button>
        </div>
        <input
          type="search"
          placeholder="Filtrar por acción, entidad…"
          className="w-full border rounded-lg px-3 py-2"
          value={auditFilter}
          onChange={(e) => setAuditFilter(e.target.value)}
        />
        <div className="border rounded-lg overflow-hidden max-h-[520px] overflow-y-auto">
          <table className="w-full text-xs">
            <thead className="bg-slate-100 sticky top-0">
              <tr>
                <th className="text-left p-2">Fecha</th>
                <th className="text-left p-2">Acción</th>
                <th className="text-left p-2">Detalle</th>
              </tr>
            </thead>
            <tbody>
              {auditFiltrada.map((row) => (
                <tr key={row._id} className="border-t border-slate-100">
                  <td className="p-2 whitespace-nowrap text-slate-500">{new Date(row.createdAt).toLocaleString('es-CL')}</td>
                  <td className="p-2 font-medium">{row.action}</td>
                  <td className="p-2 text-slate-600 break-all">
                    {row.entityType}
                    {row.meta ? ` · ${JSON.stringify(row.meta)}` : ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {auditFiltrada.length === 0 && <p className="p-4 text-slate-500 text-center">Sin registros</p>}
        </div>
      </section>
    </div>
  );
}
